.header {
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid transparent;
  transition: background-color 200ms ease, border-color 200ms ease, backdrop-filter 200ms ease;
}

.scrolled {
  background-color: color-mix(in srgb, var(--bg) 82%, transparent);
  border-bottom-color: var(--border);
  backdrop-filter: blur(12px) saturate(150%);
}

.bar {
  display: flex;
  align-items: center;
  gap: 1rem;
  min-height: 4.25rem;
}

/* --- Brand ---------------------------------------------------------------- */

.brand {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  margin-right: auto;
  color: var(--text);
  text-decoration: none;
  font-weight: 600;
  letter-spacing: -0.01em;
}

.brand:hover {
  color: var(--text);
}

.mark {
  display: grid;
  place-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: var(--radius-sm);
  background: var(--accent);
  color: var(--on-accent);
  font-family: var(--font-mono);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.brandName {
  font-size: var(--step-0);
}

@media (max-width: 26rem) {
  .brandName {
    display: none;
  }
}

/* --- Desktop nav ---------------------------------------------------------- */

.nav {
  display: none;
}

@media (min-width: 48rem) {
  .nav {
    display: block;
  }
}

.navList {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  list-style: none;
  margin: 0;
  padding: 0;
}

.navLink {
  position: relative;
  display: inline-block;
  padding: 0.5rem 0.75rem;
  border-radius: var(--radius-sm);
  color: var(--text-dim);
  font-size: var(--step--1);
  font-weight: 500;
  text-decoration: none;
  transition: color 150ms ease, background-color 150ms ease;
}

.navLink:hover {
  color: var(--text);
  background-color: var(--bg-elev-2);
}

.navLink[aria-current='true'] {
  color: var(--accent);
}

/* Underline marker for the active section — not colour alone. */
.navLink[aria-current='true']::after {
  content: '';
  position: absolute;
  left: 0.75rem;
  right: 0.75rem;
  bottom: 0.25rem;
  height: 2px;
  border-radius: 2px;
  background: var(--accent);
}

/* --- Buttons -------------------------------------------------------------- */

.actions {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.iconButton {
  display: grid;
  place-items: center;
  width: 2.25rem;
  height: 2.25rem;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  color: var(--text-dim);
  background-color: transparent;
  transition: color 150ms ease, border-color 150ms ease, background-color 150ms ease;
}

.iconButton:hover {
  color: var(--text);
  border-color: var(--border-strong);
  background-color: var(--bg-elev-2);
}

.menuButton {
  display: grid;
}

@media (min-width: 48rem) {
  .menuButton {
    display: none;
  }
}

/* --- Mobile menu ---------------------------------------------------------- */

.mobileMenu {
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  background-color: var(--bg-elev);
  box-shadow: var(--shadow-md);
}

.mobileMenu[hidden] {
  display: none;
}

@media (min-width: 48rem) {
  .mobileMenu {
    display: none;
  }
}

.mobileList {
  list-style: none;
  margin: 0;
  padding: 0.5rem var(--gutter) 1rem;
  display: grid;
  gap: 0.15rem;
}

.mobileLink {
  display: block;
  padding: 0.8rem 0.65rem;
  border-radius: var(--radius-sm);
  color: var(--text-dim);
  font-weight: 500;
  text-decoration: none;
}

.mobileLink:hover {
  color: var(--text);
  background-color: var(--bg-elev-2);
}

.mobileLink[aria-current='true'] {
  color: var(--accent);
  background-color: var(--accent-quiet);
}
